import { statusLabels } from './service';

export default function ReportFields({ required = true }: { required?: boolean }) {
  return (
    <>
      <div className="govuk-form-group">
        <label className="govuk-label" htmlFor="result">
          Have you tried this on your MacBook?
        </label>
        <select className="govuk-select" id="result" name="result" defaultValue="untested">
          {Object.entries(statusLabels).map(([value, label]) => (
            <option value={value} key={value}>
              {label}
            </option>
          ))}
        </select>
      </div>
      <div className="govuk-form-group">
        <label className="govuk-label" htmlFor="note">
          Note{required ? '' : ' (optional)'}
        </label>
        <p className="govuk-hint" id="note-hint">
          Describe the issue, workaround or alternative. Include a note if you report a working
          status. Do not include passwords or confidential information.
        </p>
        <textarea
          className="govuk-textarea"
          id="note"
          name="text"
          rows={4}
          maxLength={4000}
          required={required}
          aria-describedby="note-hint"
        />
      </div>
      <details className="govuk-details">
        <summary className="govuk-details__summary">
          <span className="govuk-details__summary-text">
            Version and MacBook details (optional)
          </span>
        </summary>
        <div className="govuk-details__text">
          <p className="govuk-body">
            Find your macOS version and chip under Apple menu, About This Mac.
          </p>
          {[
            ['app_version', 'App version'],
            ['macos_version', 'macOS version'],
            ['processor', 'Chip or processor'],
          ].map(([id, label]) => (
            <div className="govuk-form-group" key={id}>
              <label className="govuk-label" htmlFor={id}>
                {label}
              </label>
              <input
                className="govuk-input govuk-input--width-20"
                id={id}
                name={id}
                maxLength={80}
              />
            </div>
          ))}
        </div>
      </details>
    </>
  );
}
